import React from 'react'
import Collapse from '../../../blocks.simple/collapse/collapse'
import translate from '../../../core/translate'
import { cn } from 'ethcss'
import { grid } from '../../../theme'
import styles from '../settings.jcss'
import Button from '../../../blocks.simple/button/button'
import dStyles from './settings__accountDeactivation.jcss'
import Modal from '../../../blocks.simple/modal/modal'
import { api } from '../../../core/api/ConnectionManager'

export const AccountDeactivation = () => {
    const [isOpen, setIsOpen] = React.useState(false)

    const closeModal = () => {
        setIsOpen(false)
    }
    //core_v1_frontend_delete_own_user
    return (
        <>
            <Collapse title={() => translate('accountDeactivation')} className={cn(grid.mb_md, styles.background)}>
                <div>
                    <Button onClick={() => setIsOpen(true)} mod="fill">
                        {translate('deactivateAccount')}
                    </Button>
                </div>
            </Collapse>
            <Modal open={isOpen} mod={'clear'} showCloseIcon={false} modalClassName={dStyles.background}>
                <div className={dStyles.modal}>
                    <div className={dStyles.title}>{translate('deactivateAccount')}?</div>
                    <div className={styles.deleteUserDesc}>{translate('accountDeactivateConfirmDesc')}</div>
                    <div className={dStyles.buttons}>
                        <Button mod="withBorder" className={dStyles.button} onClick={closeModal}>
                            {translate('cancel')}
                        </Button>
                        <Button
                            type="submit"
                            mod={'fill'}
                            className={dStyles.button}
                            onClick={() => {
                                api.send('deleteOwnUser', {}).then(() => {
                                    closeModal()
                                })
                            }}
                        >
                            {translate('submit')}
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    )
}
